import { TTableSort } from 'src/components/table/thead/col';

import { TProductCartListSortCol } from './product-cart.type';


export type TAccountProductCartListQuery = {
	limit: number;
	offset: number;
	search?: string;
	sort?: TTableSort;
	sortCol?: TProductCartListSortCol;
};

export type TAccountProductCartListQueryRequest = {
	limit?: number;
	offset?: number;
	search?: string;
	sort?: string;
	sort_col?: string;
};

export function adaptAccountProductCartListQueryToRequest(data?: TAccountProductCartListQuery): TAccountProductCartListQueryRequest {
	if (!data) {
		return {};
	}

	const {
		sortCol,
		...restFields
	} = data;

	return {
		sort_col: sortCol,
		...restFields
	};
}

export type TAccountProductCartPayloadRequest = {
  productId: string | number;
  serialNumber: string;
  name: string;
  storageId: string;
  storageName: string;
  amount: number;
  amountType: string;
  amountMultiplicity: number;
  price: number;
  isReturnable: boolean;
  providerId: number;
  brandId: number;
  orderAmount: number;
};

export type TAccountProductCartRequest = {
  product_id: string | number;
  serial_number: string;
  name: string;
  storage_id: string;
  storage_name: string;
  amount: number;
  amount_type: string;
  amount_multiplicity: number;
  price: number;
  is_returnable: boolean;
	provider_id: number;
  brand_id: number;
  order_amount: number;
};

export function adaptAccountProductCartToRequest(data: TAccountProductCartPayloadRequest): TAccountProductCartRequest {
	const {
		productId,
		serialNumber,
		name,
		storageId,
		storageName,
		amount,
		amountType,
		amountMultiplicity,
		price,
		isReturnable,
		providerId,
		brandId,
		orderAmount,
	} = data;

	return {
		product_id: productId,
		serial_number: serialNumber,
		name: name,
		storage_id: storageId,
		storage_name: storageName,
		amount: amount,
		amount_type: amountType,
		amount_multiplicity: amountMultiplicity,
		price: price,
		is_returnable: isReturnable,
		provider_id: providerId,
		brand_id: brandId,
		order_amount: orderAmount,
	};
}

export type TProductCartIdListRequest = {
  id_list: number[];
};

export function adaptAccountProductCartIdListToRequest(ids: number[]): TProductCartIdListRequest {
	return { id_list: ids };
}
